export enum ActivityTimeRage {
    'Less than 6 month' = 1,
    'Between 1-3 Years' = 2,
    'Between 3-5 Years' = 3,
    'Above 5 years' = 4,
}